import { BanksAction } from './banks.action';
import { Bank } from '../../models/corporation/bank.model';

export interface IBanksState {
  data: Bank[];
  pending: boolean;
  error: null;
}

export const initialState: IBanksState = {
  data: [],
  pending: false,
  error: null,
};

export function BanksReducer(state: IBanksState = initialState, action?: BanksAction) {

  switch (action.type) {
    // get lista
    case BanksAction.getItems:
      return {...{}, ...state, ...{ pending: true, error: null }};

    case BanksAction.getItemsSuccess:
      return {...{}, ...state, ...{ pending: false, error: null, data: action.payload }};

    case BanksAction.getItemsError:
      return {...{}, ...state, ...{ pending: false, error: action.payload }};

    // create item
    case BanksAction.createItem:
      return {...{}, ...state, ...{ pending: true, error: null }};

    case BanksAction.createItemSuccess:
      return {...{}, ...state, ...{ pending: false, error: null }};

    case BanksAction.createItemError:
      return {...{}, ...state, ...{ pending: false, error: action.payload}};

    // update item
    case BanksAction.updateItem:
      return {...{}, ...state, ...{ pending: true, error: null }};

    case BanksAction.updateItemSuccess:
      return {...{}, ...state, ...{ pending: false, error: null }};

    case BanksAction.updateItemError:
      return {...{}, ...state, ...{ pending: false, error: action.payload}};

    // Delete item
    case BanksAction.deleteItem:
      return {...{}, ...state, ...{ pending: true, error: null}};

    case BanksAction.deleteItemSuccess:
      return {...{}, ...state, ...{ pending: false, error: null}};

    case BanksAction.deleteItemError:
      return {...{}, ...state, ...{ pending: false, error: action.payload}};

    default:
      return state;
  }
}
